/* /pages/coa — LOT lookup + sticky bar reveal. No dependencies. */
(function () {
  'use strict';

  function normalize(value) {
    return String(value || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  }

  function findCardForLot(lot, cards) {
    const target = normalize(lot);
    if (!target) return null;
    for (const card of cards) {
      // Match the current LOT
      const current = normalize(card.dataset.coaLot || '');
      if (current && current === target) return { card, archived: false };
      // Match any archived LOTs (data-coa-archive-lots is a space-separated list)
      const archived = (card.dataset.coaArchiveLots || '').split(/\s+/).map(normalize).filter(Boolean);
      if (archived.includes(target)) return { card, archived: true };
    }
    return null;
  }

  function highlight(card) {
    card.classList.add('is-matched');
    setTimeout(() => card.classList.remove('is-matched'), 2500);
  }

  function handleSearch(value, cards, errorEl) {
    if (!value || !value.trim()) {
      errorEl && errorEl.classList.remove('is-visible');
      return;
    }
    const result = findCardForLot(value, cards);
    if (result) {
      errorEl && errorEl.classList.remove('is-visible');
      result.card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      highlight(result.card);
      if (result.archived) {
        const details = result.card.querySelector('details.coa-card__archive');
        if (details) details.open = true;
      }
    } else {
      errorEl && errorEl.classList.add('is-visible');
    }
  }

  function debounce(fn, wait) {
    let t;
    return function () {
      const args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(() => fn.apply(ctx, args), wait);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    const cards = Array.from(document.querySelectorAll('[data-coa-lot]'));
    if (!cards.length) return;

    const inputs = Array.from(document.querySelectorAll('[data-coa-search]'));
    const errorEl = document.querySelector('[data-coa-no-match]');

    inputs.forEach((input) => {
      const handler = debounce(function (e) {
        handleSearch(e.target.value, cards, errorEl);
      }, 250);
      input.addEventListener('input', handler);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleSearch(e.target.value, cards, errorEl);
        }
      });
    });
  });
})();
